import effectiveDiscount from './effectiveDiscount.js'

function effectiveCombinabilityRules ({rules = [], bookingDate, party}) {
  var defaultNoneCombinable = [
    {
      childDiscount: false,
      roomTypeDiscount: false,
      groupDiscount: false,
    },
    {
      childDiscount: false,
      roomTypeDiscount: true,
      groupDiscount: true,
    },
  ]
  return rules
    .filter(
      r =>
        effectiveDiscount({discount: r, bookingDate}) &&
        (!party || party.adults + party.children > 1)
    )
    .concat(defaultNoneCombinable)
}

export default {
  effectiveCombinabilityRules,
}
